import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";

function Form() {

    const session = getUserSession();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/demonstrativetypes/';
    const paths = {
        endpointSave: config.endpoints.backend + 'demonstrativetypes/save',
        endpointGetById: config.endpoints.backend + 'demonstrativetypes/getById',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Tipo de Demonstrativo",
        labelTitleEdit: "Editar Tipo de Demonstrativo",
        labelTitleView: 'Visualizar Tipo de Demonstrativo'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
